import React, { useEffect, useMemo, useRef, useState } from "react";
import Select, { components } from "react-select";
import { TfiWorld } from "react-icons/tfi";
import "./language.css";

const languageList = [
    { code: "af", label: "Afrikaans" },
    { code: "sq", label: "Albanian" },
    { code: "am", label: "Amharic" },
    { code: "ar", label: "Arabic" },
    { code: "hy", label: "Armenian" },
    { code: "az", label: "Azerbaijani" },
    { code: "eu", label: "Basque" },
    { code: "be", label: "Belarusian" },
    { code: "bn", label: "Bengali" },
    { code: "bs", label: "Bosnian" },
    { code: "bg", label: "Bulgarian" },
    { code: "ca", label: "Catalan" },
    { code: "ceb", label: "Cebuano" },
    { code: "ny", label: "Chichewa" },
    { code: "zh-CN", label: "Chinese (Simplified)" },
    { code: "zh-TW", label: "Chinese (Traditional)" },
    { code: "co", label: "Corsican" },
    { code: "hr", label: "Croatian" },
    { code: "cs", label: "Czech" },
    { code: "da", label: "Danish" },
    { code: "nl", label: "Dutch" },
    { code: "en", label: "English" },
    { code: "eo", label: "Esperanto" },
    { code: "et", label: "Estonian" },
    { code: "tl", label: "Filipino" },
    { code: "fi", label: "Finnish" },
    { code: "fr", label: "French" },
    { code: "fy", label: "Frisian" },
    { code: "gl", label: "Galician" },
    { code: "ka", label: "Georgian" },
    { code: "de", label: "German" },
    { code: "el", label: "Greek" },
    { code: "gu", label: "Gujarati" },
    { code: "ht", label: "Haitian Creole" },
    { code: "ha", label: "Hausa" },
    { code: "haw", label: "Hawaiian" },
    { code: "he", label: "Hebrew" },
    { code: "hi", label: "Hindi" },
    { code: "hmn", label: "Hmong" },
    { code: "hu", label: "Hungarian" },
    { code: "is", label: "Icelandic" },
    { code: "ig", label: "Igbo" },
    { code: "id", label: "Indonesian" },
    { code: "ga", label: "Irish" },
    { code: "it", label: "Italian" },
    { code: "ja", label: "Japanese" },
    { code: "jv", label: "Javanese" },
    { code: "kn", label: "Kannada" },
    { code: "kk", label: "Kazakh" },
    { code: "km", label: "Khmer" },
    { code: "ko", label: "Korean" },
    { code: "ku", label: "Kurdish (Kurmanji)" },
    { code: "ky", label: "Kyrgyz" },
    { code: "lo", label: "Lao" },
    { code: "la", label: "Latin" },
    { code: "lv", label: "Latvian" },
    { code: "lt", label: "Lithuanian" },
    { code: "lb", label: "Luxembourgish" },
    { code: "mk", label: "Macedonian" },
    { code: "mg", label: "Malagasy" },
    { code: "ms", label: "Malay" },
    { code: "ml", label: "Malayalam" },
    { code: "mt", label: "Maltese" },
    { code: "mi", label: "Maori" },
    { code: "mr", label: "Marathi" },
    { code: "mn", label: "Mongolian" },
    { code: "my", label: "Myanmar (Burmese)" },
    { code: "ne", label: "Nepali" },
    { code: "no", label: "Norwegian" },
    { code: "ps", label: "Pashto" },
    { code: "fa", label: "Persian" },
    { code: "pl", label: "Polish" },
    { code: "pt", label: "Portuguese" },
    { code: "pa", label: "Punjabi" },
    { code: "ro", label: "Romanian" },
    { code: "ru", label: "Russian" },
    { code: "sm", label: "Samoan" },
    { code: "gd", label: "Scots Gaelic" },
    { code: "sr", label: "Serbian" },
    { code: "st", label: "Sesotho" },
    { code: "sn", label: "Shona" },
    { code: "sd", label: "Sindhi" },
    { code: "si", label: "Sinhala" },
    { code: "sk", label: "Slovak" },
    { code: "sl", label: "Slovenian" },
    { code: "so", label: "Somali" },
    { code: "es", label: "Spanish" },
    { code: "su", label: "Sundanese" },
    { code: "sw", label: "Swahili" },
    { code: "sv", label: "Swedish" },
    { code: "tg", label: "Tajik" },
    { code: "ta", label: "Tamil" },
    { code: "te", label: "Telugu" },
    { code: "th", label: "Thai" },
    { code: "tr", label: "Turkish" },
    { code: "uk", label: "Ukrainian" },
    { code: "ur", label: "Urdu" },
    { code: "uz", label: "Uzbek" },
    { code: "vi", label: "Vietnamese" },
    { code: "cy", label: "Welsh" },
    { code: "xh", label: "Xhosa" },
    { code: "yi", label: "Yiddish" },
    { code: "yo", label: "Yoruba" },
    { code: "zu", label: "Zulu" }
];

const getCurrentLangFromCookie = () => {
    const match = document.cookie.match(/googtrans=([^;]+)/);
    if (!match) return "en";
    const parts = decodeURIComponent(match[1]).split("/").filter(Boolean);
    return parts.length ? parts[parts.length - 1] : "en";
};

const findOptionByCode = (options, code) => {
    if (!code) return options[0];
    const exact = options.find((opt) => opt.value === code);
    if (exact) return exact;
    const lower = code.toLowerCase();
    return (
        options.find((opt) => opt.value.toLowerCase() === lower) ||
        options.find((opt) => opt.value === "en") ||
        options[0]
    );
};

const LangSingleValue = (props) => (
    <components.SingleValue {...props}>
        <span className="header-lang-single-value notranslate" translate="no">
            {props.data.label}
        </span>
    </components.SingleValue>
);

const LangOption = (props) => (
    <components.Option {...props} className={`${props.className || ""} notranslate`}>
        <div className="header-lang-option-inner" translate="no">
            <span className="header-lang-option-inner__main">{props.data.label}</span>
        </div>
    </components.Option>
);

const LanguageSelector = () => {
    const pickerRef = useRef(null);
    const selectRef = useRef(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [selectedLang, setSelectedLang] = useState(
        getCurrentLangFromCookie()
    );

    const closeLanguageMenu = () => {
        setMenuIsOpen(false);
        if (selectRef.current) {
            selectRef.current.blur();
        }
    };

    const openLanguageMenu = () => {
        setMenuIsOpen(true);
        if (selectRef.current) {
            selectRef.current.focus();
        }
    };

    useEffect(() => {
        if (!menuIsOpen) {
            return undefined;
        }

        const handleClickOutside = (event) => {
            const target = event.target;
            const insidePicker =
                pickerRef.current && pickerRef.current.contains(target);
            const insideMenu =
                typeof target.closest === "function" &&
                target.closest(".header-lang-select__menu-portal");

            if (!insidePicker && !insideMenu) {
                closeLanguageMenu();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [menuIsOpen]);

    useEffect(() => {
        if (window.googleTranslateScriptLoaded) {
            return;
        }

        window.googleTranslateScriptLoaded = true;

        window.googleTranslateElementInit = () => {
            try {
                if (
                    window.google &&
                    window.google.translate &&
                    !document.getElementById("google_translate_element")
                        ?.childNodes.length
                ) {
                    new window.google.translate.TranslateElement(
                        {
                            pageLanguage: "en",
                            autoDisplay: false,
                            includedLanguages: languageList
                                .map((lang) => lang.code)
                                .join(","),
                        },
                        "google_translate_element"
                    );
                }
            } catch (err) {
                console.error("Google Translate Init Error:", err);
            }
        };

        const existingScript = document.querySelector(
            'script[src*="translate.google.com"]'
        );

        if (!existingScript) {
            const script = document.createElement("script");

            script.src =
                "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

            script.async = true;

            script.onerror = () => {
                console.error("Failed to load Google Translate script");
            };

            document.body.appendChild(script);
        } else {
            window.googleTranslateElementInit();
        }
    }, []);

    const getBaseDomain = () => {
        const hostname = window.location.hostname;

        if (
            hostname === "localhost" ||
            hostname.includes("127.0.0.1")
        ) {
            return hostname;
        }

        const parts = hostname.split(".");

        if (parts.length <= 2) {
            return hostname;
        }

        return parts.slice(-2).join(".");
    };

    const changeLanguage = (lang) => {
        try {
            const cookieValue = `/en/${lang}`;

            setSelectedLang(lang);

            // main cookie
            document.cookie = `googtrans=${cookieValue};path=/`;

            // domain cookie only for production
            if (
                window.location.hostname !== "localhost" &&
                !window.location.hostname.includes("127.0.0.1")
            ) {
                const baseDomain = getBaseDomain();

                document.cookie = `googtrans=${cookieValue};domain=.${baseDomain};path=/`;
            }

            // apply translation directly
            const googleCombo = document.querySelector(".goog-te-combo");

            if (googleCombo) {
                googleCombo.value = lang;
                googleCombo.dispatchEvent(new Event("change"));
            } else {
                // fallback reload
                window.location.reload();
            }
        } catch (err) {
            console.error("Language Change Error:", err);
        }
    };

    const options = useMemo(
        () =>
            languageList.map((lang) => ({
                value: lang.code,
                label: lang.label,
            })),
        []
    );

    const selectedOption = useMemo(
        () => findOptionByCode(options, selectedLang),
        [options, selectedLang]
    );

    const formatOptionLabel = (option) => (
        <div className="header-lang-option-inner">
            <span className="header-lang-option-inner__main">
                {option.label}
            </span>
        </div>
    );

    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: 30,
            height: 30,
            borderRadius: 12,
            borderColor: "#d1d5db",
            boxShadow: "none",
            cursor: "pointer",
        }),

        valueContainer: (base) => ({
            ...base,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 4,
            paddingRight: 4,
            height: 30,
            display: "flex",
            alignItems: "center",
        }),

        singleValue: (base) => ({
            ...base,
            position: "relative",
            top: "auto",
            transform: "none",
            margin: 0,
            fontSize: 12,
            fontWeight: 600,
            color: "#1e293b",
            maxWidth: "100%",
        }),

        placeholder: (base) => ({
            ...base,
            position: "relative",
            top: "auto",
            transform: "none",
            margin: 0,
            fontSize: 12,
        }),

        indicatorsContainer: (base) => ({
            ...base,
            height: 30,
            alignItems: "center",
        }),

        dropdownIndicator: (base, state) => ({
            ...base,
            padding: 4,
            color: state.selectProps.menuIsOpen ? "#2563eb" : "#475569",
            transform: state.selectProps.menuIsOpen
                ? "rotate(180deg)"
                : "none",
        }),

        indicatorSeparator: () => ({
            display: "none",
        }),

        menuPortal: (base) => ({
            ...base,
            zIndex: 10050,
        }),

        menu: (base) => ({
            ...base,
            minWidth: 220,
            width: "max-content",
            maxWidth: "min(320px, calc(100vw - 24px))",
            borderRadius: 14,
            overflow: "hidden",
            boxShadow:
                "0 10px 30px rgba(0,0,0,0.12)",
            border: "1px solid #e5e7eb",
        }),

        menuList: (base) => ({
            ...base,
            maxHeight: 350,
            padding: 6,
        }),

        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused
                ? "#f3f4f6"
                : "#fff",
            color: "#111827",
            borderRadius: 10,
            cursor: "pointer",
            padding: "10px 12px",
        }),
    };

    return (
        <>
            <div
                ref={pickerRef}
                className="header-language-picker notranslate"
                aria-label="Language selector"
                role="button"
                tabIndex={0}
                onClick={openLanguageMenu}
                onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        openLanguageMenu();
                    }
                }}
            >
                <span
                    className="header-language-picker__globe"
                    aria-hidden="true"
                >
                    <TfiWorld />
                </span>

                <div className="header-language-picker__select notranslate" translate="no">
                    <Select
                        ref={selectRef}
                        key={selectedLang}
                        classNamePrefix="header-lang-select"
                        instanceId="header-language-select"
                        menuIsOpen={menuIsOpen}
                        onMenuOpen={() => setMenuIsOpen(true)}
                        onMenuClose={closeLanguageMenu}
                        options={options}
                        translate="no"
                        value={selectedOption}
                        onChange={(selected) => {
                            if (selected?.value) {
                                changeLanguage(selected.value);
                                closeLanguageMenu();
                            }
                        }}
                        components={{
                            SingleValue: LangSingleValue,
                            Option: LangOption,
                        }}
                        formatOptionLabel={formatOptionLabel}
                        styles={selectStyles}
                        classNames={{
                            menuPortal: () => "notranslate header-lang-select__menu-portal",
                            menu: () => "notranslate",
                            menuList: () => "notranslate",
                        }}
                        menuPortalTarget={
                            typeof document !== "undefined"
                                ? document.body
                                : null
                        }
                        menuPortalClassName="header-lang-select__menu-portal"
                        menuPlacement="bottom"
                        menuPosition="fixed"
                        menuShouldScrollIntoView
                        closeMenuOnScroll={false}
                        blurInputOnSelect
                        isSearchable
                        theme={(theme) => ({
                            ...theme,
                            borderRadius: 12,
                            colors: {
                                ...theme.colors,
                                primary: "#2563eb",
                                primary25: "#eff6ff",
                                primary50: "#dbeafe",
                            },
                        })}
                    />
                </div>
            </div>

            {/* hidden google translate widget */}
            <div
                id="google_translate_element"
                style={{
                    position: "absolute",
                    left: "-9999px",
                    top: "-9999px",
                }}
            />
        </>
    );
};

export default LanguageSelector;